import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import AccountComponentsMiddleware from 'yoda-account-components/lib/middlewares/AccountComponentsMiddleware';
import AccountAnalyticsMiddleware from './AccountMiddleWare';

const rootMiddleware = [AccountComponentsMiddleware, CommonMiddleware, AccountAnalyticsMiddleware];

export default rootMiddleware;
